import IncidentTypes from "../constants/IncidentTypes";
import { RouteConstants } from "../constants/RouteConstants";
import TrackingAccuracyReportStore from "./trackingAccuracyReportStore";

/**
 * Maps a Non-Game Event object to a game-like shape expected by NonMLBTrackingAccuracyReportTable.
 */
function mapEventToGame(event) {
  if (!event) return {};
  const teams = event.teams || [];
  return {
    gamePk: event.id,
    gameDate: event.eventDate,
    name: event.name,
    status: {},
    linescore: {},
    venue: event.venue || {},
    teams: {
      home: {
        team: teams[0]
          ? {
              id: teams[0].id,
              name: teams[0].name,
              abbreviation: teams[0].name,
              sport: { id: 1, abbreviation: "NGE" },
            }
          : { id: 0, name: "", abbreviation: "", sport: { id: 1, abbreviation: "NGE" } },
      },
      away: {
        team: teams[1]
          ? {
              id: teams[1].id,
              name: teams[1].name,
              abbreviation: teams[1].name,
              sport: { id: 1, abbreviation: "NGE" },
            }
          : { id: 0, name: "", abbreviation: "", sport: { id: 1, abbreviation: "NGE" } },
      },
    },
    eventTeams: teams,
    coachingVideo: event.coachingVideo || [],
    trackingVersion: event.trackingVersion || {},
  };
}

class NGETrackingAccuracyReportStore extends TrackingAccuracyReportStore {
  fetchTrackingAccuracyReport(date) {
    return this.veracityApi.fetchNGETrackingAccuracyReport(date).then((response) => {
      if (response && response.records) {
        response.records = response.records.map((record) => ({
          ...record,
          game: mapEventToGame(record.event),
        }));
      }
      return response;
    });
  }

  cancelTrackingAccuracyReport() {
    return this.veracityApi.cancelNGETrackingAccuracyReport();
  }

  isTrackingTabActive() {
    return this.routerStore.isNGETrackingAccuracyReportTab;
  }

  updateNewIncidentMetadata(game) {
    return this.veracityStore.updateNewIncidentMetadata(
      IncidentTypes.NGE,
      game,
      this.get("date"),
      RouteConstants.NGE_TRACKING,
    );
  }
}

export default NGETrackingAccuracyReportStore;
